module.exports = __webpack_public_path__ + "media/svg/sx-1775ef4c.svg";